export function getSlidesWidth({
  itemsPerView = 1,
  tail = false,
  gap = 24,
}) {
  const totalAvailableSpace = tail ? '80%' : '100%';
  const visibleGaps = itemsPerView - 1;
  const totalGapSize = gap * visibleGaps;
  return `calc((${totalAvailableSpace} - ${totalGapSize}px) / ${itemsPerView})`;
}

export const inPixels = (value) => `${value}px`;

export const inPercentage = (value) => `${value}%`;

export function checkIfHaveMultipleConfig(config) {
  return (
    typeof config === 'object' &&
    (config.hasOwnProperty('mobile') || config.hasOwnProperty('desk') || config.hasOwnProperty('tablet'))
  );
}

export function getMobileConfig(config) {
  return checkIfHaveMultipleConfig(config) ? config.mobile : config;
}

export function getTabletConfig(config) {
  return checkIfHaveMultipleConfig(config) ? config.tablet : config;
}

export function getDeskConfig(config) {
  return checkIfHaveMultipleConfig(config) ? config.desk : config;
}
